import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsAgentStudioActionsRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-agent-studio-actions',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/actions',
	exact: true,
};
